<script>
  /**
   * @type {"Document Status"|"Files"|"Dynamic Images"} active tab while generating files
   */
  export let activeItem
  /**
   * @type {String} activeColor of the tabs
   */
  export let activeColor
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  export let activeDoc
  /**
   * @type {boolean} whether to disable the tab or not
   */
  export let disabled = true

  /**
   * @type {Array<import("../Script/document".Tab)>}
   */
  export let TabList = [
    // { name: "Document Status", icon1: "fa-circle-check", icon2: "fa-clock" },
    // { name: "Files", icon1: "fa-file-check", icon2: "fa-file" },
    { name: "Publishing Status", icon1: "fa-circle-check", icon2: "fa-clock" },
    { name: "Document Status", icon1: "fa-file-check", icon2: "fa-file" },
  ]
</script>

<div class="flex min-h-[37.6px] w-full border-b border-gray-100 bg-white dark:rounded-t-md dark:border-none dark:bg-zinc-900 dark:shadow-lg">
  <div class="flex h-full w-full gap-6 px-3 font-bold text-gray-d00 mobile:px-12">
    {#each TabList as Tab}
      <!-- disabled={activeDoc == "start" && (Tab.name === "Files" || Tab.name === "Emails" || Tab.name === "Preview Generated Documents") && disabled} -->
      <button
        disabled={activeDoc == "start" && ((Tab.name === "Document Status" && TabList[0].name == "Publishing Status") || Tab.name === "Emails" || Tab.name === "Preview Generated Documents") && disabled}
        on:click={() => {
          activeItem = Tab.name
        }}
        style="color : {activeItem == Tab.name ? activeColor : '#616161'};border-color : {activeItem == Tab.name ? activeColor : 'transparent'} "
        class="tab-class disabled:cursor-not-allowed"
      >
        <i class="fa-solid {activeDoc == 'completed' ? Tab.icon1 : Tab.icon2}" />
        <p class="text-left mobile:text-center sm:w-full">{Tab.name}</p>
      </button>
    {/each}
  </div>
</div>

<style lang="postcss">
  .tab-class {
    @apply flex w-auto items-center gap-2 border-b-[3px] py-2 text-xs outline-none md:text-sm lg:text-base;
  }
</style>
